/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Score_Workflow_FitInputs */

const en_directory_score_workflow_fit = /** @type {(inputs: Directory_Score_Workflow_FitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow fit`)
};

const zh_directory_score_workflow_fit = /** @type {(inputs: Directory_Score_Workflow_FitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作流适配`)
};

/**
* | output |
* | --- |
* | "Workflow fit" |
*
* @param {Directory_Score_Workflow_FitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_score_workflow_fit = /** @type {((inputs?: Directory_Score_Workflow_FitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Score_Workflow_FitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_score_workflow_fit(inputs)
	return zh_directory_score_workflow_fit(inputs)
});
export { directory_score_workflow_fit as "directory.score.workflow_fit" }